import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {scopesFeatureKey, ScopesState} from "./scopes.reducer";

export const getScopesState = createFeatureSelector<ScopesState>(scopesFeatureKey);

export const getScopes = createSelector(getScopesState, (state) => state.data);
export const getScopesLoading = createSelector(getScopesState, SelectorUtil.isLoading);
